export default {
  color: {
    marginRight: '9px',
    height: '34px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: 'rgb(246, 246, 246)',
  }
};



// WEBPACK FOOTER //
// ./src/common/ColorPicker2/style.js